"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ImageCard = _interopRequireDefault(require("../block/ImageCard"));
var _Loading = _interopRequireDefault(require("../utils/Loading"));
var _AirDateFormatter = _interopRequireDefault(require("../utils/AirDateFormatter"));
var _helpers = require("../../utils/helpers");
var _programHelpers = require("../../utils/program-helpers");
require("./../../scss/lists/FeaturedList.module.scss");
function FeaturedList(_ref) {
  let {
    list = [],
    imageAspectRatio = 800 / 1393,
    hasSeriesPages = true,
    handleClicks = () => {}
  } = _ref;
  if (list === null) return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Loading.default, null));
  if (list.length) return /*#__PURE__*/_react.default.createElement("featured-list", null, list.map(item => {
    var _item$content$image, _item$content, _item$content2;
    return /*#__PURE__*/_react.default.createElement(_ImageCard.default, {
      image: {
        url: (_item$content$image = item === null || item === void 0 || (_item$content = item.content) === null || _item$content === void 0 ? void 0 : _item$content.image) !== null && _item$content$image !== void 0 ? _item$content$image : '',
        aspectRatio: imageAspectRatio,
        altText: item.program
      },
      content: /*#__PURE__*/_react.default.createElement(_AirDateFormatter.default, {
        airdateStr: "".concat(item.start_date, " ").concat((0, _helpers.convert12to24)(item.start_time)),
        separatorType: "pipe"
      }),
      fullCardClickable: true,
      handleClicks: !hasSeriesPages ? handleClicks : () => {},
      cta: {
        label: 'View Upcoming',
        href: item !== null && item !== void 0 && (_item$content2 = item.content) !== null && _item$content2 !== void 0 && _item$content2.slug && hasSeriesPages ? item.program_class === 'Film' ? "/movie/".concat(item.content.slug) : "/show/".concat(item.content.slug) : '',
        type: hasSeriesPages ? 'internal-link' : 'show-modal',
        relatedResourceId: item.program_class === 'Film' ? item.title_code : (0, _programHelpers.determineSeriesPrefix)(item.series_prefix),
        relatedResourceType: item.program_class === 'Film' ? 'film' : 'series'
      },
      relatedResourceId: item.program_class === 'Film' ? item.title_code : (0, _programHelpers.determineSeriesPrefix)(item.series_prefix),
      displayCTA: false,
      key: "featured-list-".concat(item.id)
    });
  }));
  if (!list.length) return /*#__PURE__*/_react.default.createElement("div", {
    className: "featured-list__no-results"
  }, "There are no items to display.");
}
var _default = exports.default = FeaturedList;